// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__TXa4J","printable":"Page_printable__nfKl0"};